import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Role } from '../../enums/role';
import { UserStatus } from '../../models/dashboard';
import { StatusDatePipe } from '../../utilities/date-pipes';
import { Functions } from '../../utilities/functions';
import { Reset } from '../../utilities/reset';

@Component({
  selector: '[app-user-status-row]',
  imports: [
    FormsModule,
    CommonModule,
    ButtonModule,
    TranslatePipe,
    TagModule,
    StatusDatePipe
  ],
  templateUrl: './user-status-row.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class UserStatusRowComponent {
  @Input() user: UserStatus = Reset.userStatus();
  @Input() maxRole: number = Role.patient;
  @Input() isShowing: boolean = false;

  showRequest = output<UserStatus>();

  showDisabled: boolean = false;

  ngOnChanges() {
    if (this.user !== undefined || this.user !== null) {
      const role = Math.min(...this.user.roles);
      this.showDisabled = role < this.maxRole;
    } else {
      this.showDisabled = false;
    }
  }

  getRoleName(role: number): string {
    return Functions.getRoleName(role);
  }

  getRoleSeverity(role: number) {
    return Functions.getRoleSeverity(role);
  }

  onShowDialog(): void {
    this.showRequest.emit(this.user);
  }
}
